'use client';

import { styled } from '@linaria/react';
import PopTopicInfiniteListSkeleton from '@fe-news/components/molecules/PopTopicInfiniteList/PopTopicInfiniteListSkeleton';
import PopTopicTimelineFilter from '@fe-news/components/molecules/PopTopicTimelineFilter';

const Container = styled.div`
  position: relative;
`;

const Wrapper = styled.div`
  margin-top: 24px;
  padding-left: 12px;
  padding-right: 6px;

  &::before {
    content: '';
    position: absolute;
    left: 17px;
    height: 100%;
    border-left: 2px dotted rgba(84, 181, 198, 0.5);
    z-index: 0;
  }
`;

const PopTopicTimelineSkeleton = () => {
  return (
    <Container>
      <PopTopicTimelineFilter />
      <Wrapper>
        <PopTopicInfiniteListSkeleton isTimeline />
      </Wrapper>
    </Container>
  );
};

export default PopTopicTimelineSkeleton;
